const THREE_DAYS_MS = 3 * 24 * 60 * 60 * 1000;
const DAY_MS = 24 * 60 * 60 * 1000;

export default function getTrialStatus(currentUser, now = Date.now()) {
  const createdAt = currentUser?.createdAt || currentUser?.created_at;
  const creationTime = createdAt ? new Date(createdAt).getTime() : NaN;
  const customTrialEnd = currentUser?.trialEndsAt || currentUser?.trial_ends_at;
  const trialEnd = customTrialEnd
    ? new Date(customTrialEnd).getTime()
    : creationTime + THREE_DAYS_MS;
  const freeAccess = Boolean(currentUser?.freeAccess || currentUser?.free_access);
  const hasClassAccess = Boolean(currentUser?.hasClassAccess);
  const paidUntil = currentUser?.paidAccessUntil;
  const isSubscribed = Boolean(currentUser?.isSubscribed) &&
    (!paidUntil || now < new Date(paidUntil).getTime());
  const isTrialActive = !freeAccess && !hasClassAccess && !isSubscribed &&
    Number.isFinite(creationTime) && now >= creationTime && now < trialEnd;
  const remainingDays = isTrialActive
    ? Math.ceil((trialEnd - now) / DAY_MS)
    : 0;

  return {
    isTrialActive,
    remainingDays,
    hasAccess: isSubscribed || freeAccess || hasClassAccess || isTrialActive,
    isSubscribed,
    freeAccess,
    hasClassAccess,
  };
}
